export default {"src":"/_next/static/media/HomeProcess.96774e43.svg","height":434,"width":572};